import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {view as App} from '../entry_app/';
import store from '../store/app.js';
import { Provider } from 'react-redux';
import {Router, Route, Switch} from 'react-router-dom';
// import createHashHistory from 'history/createHashHistory';
import { QuestionTML } from '@/entry_app/question_manage/question_tml';

/**管理页***/

const history = require("history").createHashHistory();
// const history = createHashHistory();

const render = () => (
    ReactDOM.render(
        <Provider store={store}>
            <Router history={history}>
                <Switch>
                    <Route exact path="/questionTML" component={QuestionTML}/>
                    <Route exact path="/questionTML/(.*)" component={QuestionTML}/>
                    <Route path="/" component={App}/> 
                </Switch>
            </Router>
        </Provider>, document.getElementById('root'))
)
render();




// WEBPACK FOOTER //
// ./src/entries/index.js